        angular.module('myApp.fatafat', ['ngRoute','ngAnimate'])

            .config(['$routeProvider', function($routeProvider) {

                $routeProvider.when('/grocery', {
                    templateUrl: 'components/Fatafat/fatafat.html',
                    controller: 'fatafatCtrl'
                })
                $routeProvider.when('/grocery/:city_name/:subCatId', {
                    templateUrl: 'components/Fatafat/fatafatItems.html',
                    controller: 'fatafatItemsCtrl'
                })
                $routeProvider.when('/grocery/:city_name', {
                    templateUrl: 'components/Fatafat/fatafatCategories.html',
                    controller: 'fatafatCategoriesCtrl'
                })
            }])
                .controller('fatafatCtrl'  , ['$scope','$rootScope','$window', '$timeout','$location','API',function( $scope,$rootScope,$window,$timeout,$location,API) {

                    $scope.cityList={};
                    $scope.getCities = getCities;

                    sessionStorage.removeItem('cart');
                    function getCities() {
                            $rootScope.loading_custom = true;
                            return API.get(fatafat_base_url + 'get_cities')

                                .then(function (result) {
                                 $scope.cityList=result.data.cities;
                                 $rootScope.loading_custom = false;
                            });


                    }
                    getCities();


                    function chunk(arr, size) {
                        var newArr = [];
                        for (var i = 0; i < arr.length; i += size) {
                            newArr.push(arr.slice(i, i + size));
                        }
                        return newArr;
                    }

                    $scope.fatafatCities = [
                        {
                            name : 'Chandigarh',
                            link : 'chandigarh'
                        },
                        {
                            name : 'Ludhiana',
                            link : 'ludhiana'
                        },
                        {
                            name : 'Gurgaon',
                            link : 'gurgaon'
                        },
                        {
                            name : 'Indore',
                            link : 'indore'
                        },
                        {
                            name : 'Ahemdabad',
                            link : 'ahmedabad'
                        },
                        {
                            name : 'Noida',
                            link : 'noida'
                        },
                        {
                            name : 'Jaipur',
                            link : 'jaipur'
                        },
                        {
                            name : 'vadodara',
                            link : 'vadodara'
                        },
                        {
                            name : 'Bhubaneswar',
                            link : 'bhubaneswar'
                        },
                        {
                            name : 'Mysore',
                            link : 'mysore'
                        },
                        {
                            name : 'Surat',
                            link : 'surat'
                        },
                        {
                            name : 'Coimbatore',
                            link : 'coimbatore'
                        }
                    ].sort(function(a, b) {
                        var nameA = a.name.toUpperCase();
                        var nameB = b.name.toUpperCase();
                        if (nameA < nameB) {
                            return -1;
                        }
                        if (nameA > nameB) {
                            return 1;
                        }
                        return 0;
                    });

                    $scope.citySelected=function () {

                        $location.path("/grocery/"+$scope.selectedCity.cityDetails.city_name.toLowerCase());
                    }

                }])


                .controller('fatafatItemsCtrl',['$scope','$rootScope','$route','$window', '$timeout','$mdSidenav','$mdDialog','API','$routeParams','$location','$rootScope',function( $scope, $rootScope, $route, $window,$timeout,$mdSidenav,$mdDialog,API,$routeParams,$location,$rootScope) {



                   $rootScope.loading_custom = true;
                    $scope.viewSidenav = false;
                    $scope.msg='';
                    $scope.flag = 143;
                      $scope.cityName = $routeParams.city_name;
                       $scope.cityName =   $scope.cityName.charAt(0).toUpperCase() +  $scope.cityName.substr(1).toLowerCase();
                        var subCatId = $routeParams.subCatId;
                        $scope.currentCat = subCatId;

                    $scope.showStores = function () {
                        $('#storeSelector').toggleClass("show-dd");
                    }

                    // $(window).on("scroll", function () {
                    //     if ($(this).scrollTop() > 40) {
                    //         $('#menu1').addClass('white-background');
                    //         $('#menu2').addClass('white-background');
                    //         $('#top-bar').addClass('slide-up');
                    //         $('#store-arrow').attr('src', '../images/caret-copy.png');
                    //         $('#cart-img').attr('src', '../images/combined-shape-copy.png');
                    //         $('#left-arrow').attr('src', '../images/caret.png');
                    //
                    //     }
                    //     else {
                    //         $('#menu1').removeClass('white-background');
                    //         $('#menu2').removeClass('white-background');
                    //         $('#top-bar').removeClass('slide-up');
                    //         $('#store-arrow').attr('src', '../images/storeArrow.png');
                    //         $('#cart-img').attr('src', '../images/cartSmall.png');
                    //         $('#left-arrow').attr('src', '../images/cartArrow.png');
                    //     }
                    // });


                    $scope.getItems=function (subCatId,param) {

                        if(param) {
                            $mdSidenav('super-menu').toggle();
                        }
                     console.log(subCatId,param)
                        $location.path("/grocery/"+$scope.cityName.toLowerCase()+"/"+subCatId)
                    }

                    $scope.redirectUrl = function () {
                        $location.path("/grocery/"+$scope.cityName.toLowerCase());
                    }




                        $scope.catName = [];

                        $scope.selectedCity={};


                        $scope.cities=
                        [{"city_id":1,"city_name":"Chandigarh","latitude":30.719047,"longitude":76.810808},{"city_id":2,"city_name":"Ludhiana","latitude":30.90828,"longitude":75.851521},{"city_id":7,"city_name":"Gurgaon","latitude":28.460817,"longitude":77.076807},{"city_id":8,"city_name":"Indore","latitude":22.727078,"longitude":75.85766},{"city_id":11,"city_name":"Ahmedabad","latitude":23.027264,"longitude":72.58056},{"city_id":17,"city_name":"Noida","latitude":28.5885,"longitude":77.3611},{"city_id":4,"city_name":"Jaipur","latitude":26.871286,"longitude":75.78079},{"city_id":14,"city_name":"Vadodara","latitude":22.3196,"longitude":73.1669},{"city_id":22,"city_name":"Bhubaneswar","latitude":20.3028,"longitude":85.8239},{"city_id":21,"city_name":"Mysore","latitude":12.3111,"longitude":76.6426},{"city_id":15,"city_name":"Surat","latitude":21.1544,"longitude":72.8197},{"city_id":25,"city_name":"Coimbatore","latitude":11.0093,"longitude":76.9624}];

                         for(i=0;i<$scope.cities.length;i++)
                             {
                                 if($scope.cityName==$scope.cities[i].city_name)
                                     {
                                         $scope.selectedCity=$scope.cities[i];
                                         break;
                                     }
                             }


                          API.post(fatafat_base_url + 'get_super_categories', {
                            access_token: guestToken,
                            latitude:localStorage.getItem('lat'),
                            longitude:localStorage.getItem('long'),
                              device_type:2,

                    })
                        .then(function (result) {
                            $scope.subCatList=result.data.super_categories;
                        for(a=0;a<$scope.subCatList.length;a++)
                            {
                          if($scope.currentCat==$scope.subCatList[a].super_category_id)
                              {
                                 $scope.category=$scope.subCatList[a]
                                 break;
                              }
                            }

                        })








                     $scope.regMob = /^[1-9][0-9]{9}$/;
                    $scope.findItems=findItems;
                 /*    $scope.searchText = {};
                    $scope.searchText.name = null;  */
                    $scope.categories=[];
                    $scope.selectedStore;
                    $scope.placeOrder=false;
                    // $scope.showMore=0;
                    $scope.chosenPlace='';
                    $scope.cart=[];
                    $scope.cartTotal=0;
                    if(sessionStorage.getItem('cart')){
                        $scope.cart = JSON.parse(sessionStorage.getItem('cart'));
                        console.log($scope.cart);
                        for(var i=0;i<$scope.cart.length;i++)
                        {
                            $scope.cartTotal=$scope.cartTotal+($scope.cart[i].price*$scope.cart[i].quantLength);
                        }
                    };
                    $scope.finalCart=[];
                    $scope.checkout_data=[];
                    $scope.showMoreFxn=function (index) {
                        // $scope.showMore=1
                        // $scope.limit = undefined;
                        document.getElementById(2*(index+1)).style.display = "none";
                        document.getElementById(2*(index+1)+1).style.display = "block";
                    };
                    $scope.showLessFxn=function (index) {
                        // $scope.showMore=0
                        // $scope.limit = 12;
                        document.getElementById(2*(index+1)).style.display = "block";
                        document.getElementById(2*(index+1)+1).style.display = "none";
                    };

                    $scope.showOrderDiv=function () {
                         $scope.finalCart=[];
                        var transform = function (data) {
                            return $.param(data);
                        };
                        if( $scope.cart.length>0)
                            {
                        $scope.placeOrder=true;
                            }
                        for(var i=0;i<$scope.cart.length;i++)
                        {
                            var obj={"sub_item_id":$scope.cart[i].sub_item_id,
                                    "quantity":$scope.cart[i].quantLength,
                                    "sub_item_name":$scope.cart[i].sub_item_name
                                       }
                            $scope.finalCart.push(obj)
                        }

                        API.post(fatafat_base_url + 'user_checkout_data', {
                            access_token: guestToken,
                            latitude:$scope.selectedCity.latitude,
                            longitude:$scope.selectedCity.longitude,
                            cart:JSON.stringify($scope.finalCart),
                            vendor_id:$scope.selectedStore.vendor_id

                        })
                            .then(function (result) {
                                $scope.checkout_data=result.data.checkout_data;

        ////////////////////////////////////////// SLOTS //////////////////////////////////
                        $scope.daySlots = [];
                        $scope.obj1 = {};
                        $scope.finalDeliverySlots = [];


                        for (val in $scope.checkout_data.delivery_slots) {
                            $scope.obj1 = {
                                'dayName': $scope.checkout_data.delivery_slots[val].day_name,
                                'slots': $scope.checkout_data.delivery_slots[val].slots
                            }
                            $scope.daySlots.push($scope.obj1);
                        }
                        for (val in $scope.daySlots) {
                            for (val1 in $scope.daySlots[val].slots) {
                                $scope.obj1 = {
                                    'dayName': $scope.daySlots[val].dayName,
                                    'startTime': $scope.daySlots[val].slots[val1].start_time,
                                    'endTime': $scope.daySlots[val].slots[val1].end_time,
                                    'thresholdTime': $scope.daySlots[val].slots[val1].threshold_time,
                                    'slotId': $scope.daySlots[val].slots[val1].delivery_slot_id,
                                    'is_enabled': $scope.daySlots[val].slots[val1].is_enabled
                                }
                                var strttimeTokens = $scope.obj1.startTime.split(':');
                                var endtimeTokens = $scope.obj1.endTime.split(':');
                                $scope.obj1.startTime = new Date(1970, 0, 1, strttimeTokens[0], strttimeTokens[1], strttimeTokens[2]);
                                $scope.obj1.endTime = new Date(1970, 0, 1, endtimeTokens[0], endtimeTokens[1], endtimeTokens[2]);
                                $scope.finalDeliverySlots.push($scope.obj1);
                            }
                        }




        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    })
                    }

                    $scope.chosenPlace="";
                    $scope.lastAddress=null;

                      $scope.sendOrder = function () {



                                           if ($scope.lastAddress == null) {
                                       $scope.Address = $scope.chosenPlace;
                                              } else {
                                           $scope.Address = $scope.lastAddress + ',' + ' ' + $scope.chosenPlace;
                                            }
                                           $scope.addre = $scope.chosenPlace;
                                            if ($scope.chosenPlace) {
                                              console.log("aaaaaaaaaa",$scope.chosenPlace);
                                            geocoder = new google.maps.Geocoder();
                                             if (geocoder) {
                                              var address = $scope.addre;
                                              geocoder.geocode({
                                            'address': address
                                               }, function (results, status) {
                                            if (status == google.maps.GeocoderStatus.OK) {
                                                $scope.mydstlat = results[0].geometry.location.lat();
                                                $scope.mydstlong = results[0].geometry.location.lng();
                                                 $rootScope.loading_custom = true;


                                                API.post( fatafat_base_url + 'place_order', {
                                                     promo_code: "",
                                                    cart: JSON.stringify($scope.finalCart),

                                                     latitude:localStorage.getItem('lat'),
                                                     longitude:localStorage.getItem('long'),
                                                    delivery_address: $scope.Address,
                                                    delivery_latitude: $scope.mydstlat,
                                                    delivery_longitude: $scope.mydstlong,
                                                    payment_mode:1,
                                                    delivery_notes: "",
                                                     source: 1,
                                                    delivery_slot_id: $scope.group1,
                                                     access_token: guestToken,
                                                    is_guest : 1,
                                                    user_name: $scope.gName,
                                                    phone_no : $scope.gPhone,
                                                    vendor_id: $scope.selectedStore.vendor_id

                                  })
                                        .then(function (result) {
                                                    $scope.closeSidenav();
                                                console.log("final result",result);
                                                   $scope.orderDetails=result.data;

                                                    console.log("orderDetails", $scope.orderDetails)
                                                     for (val in $scope.finalDeliverySlots) {
                                                            if ($scope.group1 == $scope.finalDeliverySlots[val].slotId) {

                                                                $scope.selStrtTime = $scope.finalDeliverySlots[val].startTime;
                                                                $scope.selEndTime = $scope.finalDeliverySlots[val].endTime;
                                                                $scope.selDayName = $scope.finalDeliverySlots[val].dayName;

                                                            }
                                                        }


                                                    /* $mdSidenav('left').toggle();
                                                    $scope.placeOrder=false;
                                       */         $rootScope.loading_custom = false;
                                                 if(result.data.flag==144)
                                                     {
                                              alert = $mdDialog.alert({

                                                //closeByEscape:true,
                                              templateUrl:"unsuccessmsg",
                                              scope:$scope
                                               });

                                              $mdDialog
                                             .show( alert )
                                             .finally(function() {
                                               alert = undefined;
                                                 });
                                                }
                                                 else
                                                     {
                                              alert = $mdDialog.alert({

                                                //closeByEscape:true,
                                              templateUrl:"successmsg",
                                              scope:$scope
                                               });

                                              $mdDialog
                                             .show( alert )
                                             .finally(function() {
                                               alert = undefined;
                                                 });
                                                }

                                            })


                                            }
                                              })
                                             }
                                            }




                                     /*       var reqObj = {
                                                    "promo_code": "",
                                                    "cart": JSON.stringify($scope.finalCart),
                                                    "latitude": 30.735172533662894,
                                                    "longitude": 76.8444884964265,
                                                    "delivery_address": $scope.Address,
                                                    "delivery_latitude": $scope.mydstlat,
                                                    "delivery_longitude": $scope.mydstlong,
                                                    "payment_mode":1,
                                                    "delivery_notes": '',
                                                    "source": 1,
                                                    "delivery_slot_id": $scope.group,
                                                     access_token:"291d265e0aef8a74d91bccfb743c67b8548e9140d35c2f0b1ae5c88cdb7f5408"
                                                };
                      */
                                            /*
                                                API.post(BASE_URL + 'place_order', reqObj, {

                                                }).then(function (res) {

                                                    console.log(res);

                                                })*/



                    }




        /////////////////////////////////////////// ADDRESS ////////////////////////////////////////////////////////

                /*    function googleplace() {
                        return {
                            require: 'ngModel',
                            link: function (scope, element, attrs, model) {
                                var options = {
                                    types: [],
                                    componentRestrictions: {}
                                };
                                scope.gPlace = new google.maps.places.Autocomplete(element[0], options);

                                google.maps.event.addListener(scope.gPlace, 'place_changed', function () {
                                    scope.$apply(function () {
                                        model.$setViewValue(element.val());
                                    });
                                });
                            }
                        };
                    }
        */
            //             function initialize() {
            //
            //     var input = document.getElementById('searchBox');
            //     var autocomplete = new google.maps.places.Autocomplete(input);
            //
            //     autocomplete.addListener('place_changed', function () {
            //         var place = autocomplete.getPlace();
            //         if (!place.geometry) {
            //             // User entered the name of a Place that was not suggested and
            //             // pressed the Enter key, or the Place Details request failed.
            //             window.alert("No details available for input: '" + place.name + "'");
            //             return;
            //         }else{
            //             console.log(place.geometry.location.lat(),place.geometry.location.lng());
            //             API.get(url+ place.geometry.location.lat() +','+place.geometry.location.lng());
            //         }
            //     });
            // }
            //
            //
            // google.maps.event.addDomListener(window, 'load', initialize);


                    // function initialize() {
                    //     var input = document.getElementById('searchBox');
                    //     var autocomplete = new google.maps.places.Autocomplete(input);
                    //     google.maps.event.addListener(autocomplete, 'place_changed', function () {
                    //         var place = autocomplete.getPlace();
                    //         var lat = place.geometry.location.lat();
                    //         var lon = place.geometry.location.lng();
                    //         $scope.$apply();
                    //         //alert("This function is working!");
                    //         //alert(place.name);
                    //         // alert(place.address_components[0].long_name);
                    //     });
                    // }
                    // google.maps.event.addDomListener(window, 'load', initialize);

        ///////
                      $scope.closeSidenav= function(){
                            $mdSidenav('left').toggle();
                      }



                   function findItems() {

                       $scope.msg = '';
                      $rootScope.loading_custom = true;
                            return API.post(fatafat_base_url+ 'get_item_search', {
                                search_string: $scope.searchText,
                                city_id: $scope.selectedCity.city_id,
                                website:1,
                                super_category_id:subCatId,
                                vendor_id:$scope.selectedStore.vendor_id,
                                access_token: guestToken,

                            })

                                .then(function (result) {
                                    $scope.flag = result.data.flag;
                                    $scope.msg = result.data.message;
                                     $rootScope.loading_custom = false;
                                $scope.categories=[];
                                $scope.obj1={};
                                console.log("search",result.data)


                                 for (val in result.data.item_info)

                                     {
                                         if(result.data.item_info[val].super_category_id==subCatId)
                                             {

                                         for(item in result.data.item_info[val].categories)
                                        {

                                              $scope.obj1 = {
                                    'category_id':result.data.item_info[val].categories[item].category_id,
                                    'category_image':result.data.item_info[val].categories[item].category_image,
                                    'category_name': result.data.item_info[val].categories[item].category_name,
                                    'sub_items': result.data.item_info[val].categories[item].sub_items

                                                          }
                                               $scope.categories.push($scope.obj1);
                                        }

                                      }
                                     }






                                   console.log("data" ,result.data);
                                    console.log("cat" ,$scope.categories);
                                });

                    }
                        $scope.searchempty=function() {

                            $scope.msg = '';

                           if($scope.searchText=="")
                               {
                                     $rootScope.loading_custom = true;
                                     API.post(fatafat_base_url + 'get_all_products', {
                        access_token: guestToken,
                          latitude:localStorage.getItem('lat'),
                            longitude:localStorage.getItem('long'),
                        super_category_id:subCatId,
                        is_fatafat:1,
                        app_version:275,
                        device_type:0

                    })
                        .then(function (result) {
                            $scope.categories=result.data.categories;
                            $scope.stores=result.data.delivery_stores;
                            $scope.selectedStore=result.data.delivery_info;
                            $rootScope.loading_custom = false;
                            $scope.flag = result.data.flag;
                            $scope.msg = result.data.message;

                        })

                               }



                       }






                    // $scope.showDialog = showDialog;


                    $scope.closeDialog=function(){

                        $window.location.reload();

                    }

                    $(window).on("scroll", function () {                    // for fixing the download app div to the top
                        if($(this).scrollTop() >= 536) {
                            $("#sidebar").addClass("stickSidebar");
                        }
                        else{
                            $("#sidebar").removeClass("stickSidebar");
                        }
                    })


                    function getCities() {
                        return API.get(fatafat_base_url + 'get_cities')

                            .then(function (result) {
                                var data = result.data;
                                console.log(data);
                                $scope.cityList=data.cities;
                                console.log("Response",$scope.cityList)

                            });


                    }
                    getCities()

                    API.post(fatafat_base_url+ 'get_super_categories', {
                        access_token: guestToken,
                        latitude:localStorage.getItem('lat'),
                        longitude:localStorage.getItem('long'),

                    })
                        .then(function (result) {
                        $scope.subCatList=result.data.super_categories;
                            if($scope.subCatList && $scope.subCatList.length) {
                                $scope.catName = $scope.subCatList.filter(function (item) {
                                    return (item.super_category_id == $routeParams.subCatId)
                                });
                            }
                        });



                    API.post(fatafat_base_url + 'get_all_products', {
                         access_token: guestToken,
                          latitude:localStorage.getItem('lat'),
                            longitude:localStorage.getItem('long'),
                        super_category_id:subCatId,
                        is_fatafat:1,
                        app_version:275,
                        device_type:0

                    })
                        .then(function (result) {
                            $scope.categories=result.data.categories;
                            $scope.stores=result.data.delivery_stores;
                            $scope.selectedStore=result.data.delivery_info;
                         console.log("all",result.data)
                            if($scope.categories && $scope.categories.length) {
                                $scope.categories.forEach(function (items) {
                                    items.sub_items.forEach(function (item) {
                                        for ( var x in $scope.cart) {
                                            if($scope.cart[x].sub_item_id == item.sub_item_id) {
                                                item["quantLength"] = $scope.cart[x].quantLength;
                                            }
                                        }
                                    })
                                });
                            }

                            //console.log(JSON.stringify($scope.categories));

                            $rootScope.loading_custom = false;
                            $scope.viewSidenav = true;
                            $scope.flag = result.data.flag;
                            $scope.msg = result.data.message;

                        });

                    $scope.cityChanged=function () {

                         $scope.cart=[];            //alert box display to empty the cart or not
                            $scope.cartTotal=0;
                        sessionStorage.removeItem('cart');
                        localStorage.setItem('lat', $scope.selectedCity.latitude);
                        localStorage.setItem('long', $scope.selectedCity.longitude);
                        localStorage.setItem('city_id',$scope.selectedCity.city_id);
                        $rootScope.userLocation = $scope.selectedCity.city_name;
                        localStorage.setItem('userLocation',$scope.selectedCity.city_name);
                        console.log($scope.selectedCity);
                        $location.path("/grocery/"+$scope.selectedCity.city_name.toLowerCase());



                    }

                    $scope.items = [1, 2, 3, 4, 5, 6, 7, 8];

                    $scope.properties = {
                        items: 7,
                        dots:false,
                        nav:true,
                        stagePadding:50,
                        navText:["<img src=' images/arrowLeftFatafat.png'>","<img src='images/arrowRightFatafat.png '>" ],
                        responsiveClass:true,
                        responsive: {
                            0: {
                                items: 2,
                                nav: true,
                                stagePadding:20
                            },
                            600: {
                                items: 4,
                                nav: false
                            },
                            1000: {
                                items: 7,
                                nav: true,

                            },
                            1300:
                            {
                                items: 8,
                                nav: true,

                            }
                        }



                    };

                    // $scope.ready = function ($api) {
                    //     owlAPi = $api;
                    // };
                    //
                    // $timeout(function () {
                    //     console.dir(owlAPi);
                    //     owlAPi.trigger('next.owl.carousel',[2000]);
                    // }, 2000)


                    $scope.getStore=function (value) {
                        $scope.categories=[];
                        $scope.stores=[];
                        $scope.selectedStore=[];

                        API.post(fatafat_base_url + 'get_all_products', {
                             access_token: guestToken,
                            latitude:localStorage.getItem('lat'),
                            longitude:localStorage.getItem('long'),
                            super_category_id:subCatId,
                            vendor_id:value.vendor_id,
                            is_fatafat:1,
                            app_version:275,
                            device_type:0

                        })
                            .then(function (result) {
                                $scope.categories=result.data.categories;
                                $scope.stores=result.data.delivery_stores;
                                $scope.selectedStore=result.data.delivery_info;
                            console.log("selected store",$scope.selectedStore)

                             $scope.cart=[];            //alert box display to empty the cart or not
                            $scope.cartTotal=0;

                            })

                    }



            $scope.cartBtn=true;


                    $scope.displayCartBtn=function (item) {
                        // var counter=0
                        for (var i = 0; i < $scope.cart.length; i++) {
                            if (!$scope.cart[i].sub_item_name) {
                                $scope.cartBtn=true;
                                return $scope.cartBtn;
                                break;
                            }
                            //     counter++
                            //
                            // }
                            // if(counter==$scope.cart.length)
                            // {
                            //     return true;
                            // }
                        }
                    }


                    $("#store").on("show.bs.dropdown", function(event){
                        $(this).find('.dropdown-menu').first().stop(true, true).slideDown();
                    })
                    $("#store").on("hide.bs.dropdown", function(event){
                        $(this).find('.dropdown-menu').first().stop(true, true).slideUp();
                    })



                    $scope.addItem=function (item) {

                        if(item.stock) {

                            if (!item.hasOwnProperty('quantLength') || item.quantLength == 0) {

                                item.quantLength = 1;

                            } else {
                                if (item.stock > item.quantLength) {
                                    item.quantLength += 1;
                                }
                                else {

                                    if (item.stock > 1)
                                        $scope.content = "Can't order more than " + item.stock + " units"
                                    else
                                        $scope.content = "Can't order more than " + item.stock + " unit"
                                    $("#maxLimit").modal("show");
                                }
                            }

                            var product = angular.copy(item);

                            $scope.cartTotal = 0;
                            if (!$scope.cart.length) $scope.cart.push(product);
                            else {
                                var index = 0;
                                for (var i in $scope.cart) {
                                    if ($scope.cart[i].sub_item_id == product.sub_item_id) {
                                        $scope.cart[i].quantLength = product.quantLength;
                                        index = 1;
                                    }
                                }
                                if (!index) {
                                    $scope.cart.push(product);
                                }
                            }
                            calculateTotal();
                        }
                        else{
                            $scope.content = "Can't order more than " + item.stock + " unit"
                            $("#maxLimit").modal("show");
                        }
                    };

                    $scope.addItemCart=function (item) {

                        $scope.cartTotal = 0;

                            if(item.stock > item.quantLength)
                            {
                                item.quantLength += 1;
                                $scope.categories.forEach(function (items) {
                                    items.sub_items.forEach(function (i) {

                                            if( i.sub_item_id == item.sub_item_id) {
                                                i["quantLength"] = item.quantLength;
                                            }

                                    })
                                });

                                calculateTotal();
                            }
                            else{
                                 $scope.closeSidenav();
                                if(item.stock > 1)
                                  $scope.content = "Can't order more than " + item.stock + " units"
                                 else
                                 $scope.content = "Can't order more than " + item.stock + " unit"
                                  $("#maxLimit").modal("show");
                            }




                    };


                    $scope.subtractItem=function (item) {

                        $scope.cartTotal = 0;
                        if(!$scope.cart.length || item.quantLength == 0) return false;
                        else {
                            item.quantLength -= 1;
                            var index = -1;
                            var remove = 0;
                            for (var i in $scope.cart) {
                                if($scope.cart[i].sub_item_id == item.sub_item_id) {
                                    $scope.cart[i].quantLength = item.quantLength;
                                    remove = $scope.cart[i].quantLength == 0 ? 1 : remove;
                                    index = i;
                                }
                            }
                            if(remove) {
                                $scope.cart.splice(index,1);
                            }
                        }
                        calculateTotal();
                    };



                    $scope.subtractItemCart=function (item) {

                        $scope.cartTotal = 0;
                            item.quantLength -= 1;
                            var index = -1;
                            var remove = 0;
                            for (var i in $scope.cart) {
                                if($scope.cart[i].sub_item_id == item.sub_item_id) {
                                    $scope.cart[i].quantLength = item.quantLength;
                                    remove = $scope.cart[i].quantLength == 0 ? 1 : remove;
                                    index = i;
                                }
                            }


                        $scope.categories.forEach(function (items) {
                            items.sub_items.forEach(function (i) {

                                    if(i.sub_item_id == item.sub_item_id) {
                                        i["quantLength"] = item.quantLength;
                                    }

                            })
                        });

                        if(remove) {
                            $scope.cart.splice(index,1);
                        }

                        calculateTotal();

                    };

                    function calculateTotal() {

                        for(var i=0;i<$scope.cart.length;i++)
                        {
                            $scope.cartTotal=$scope.cartTotal+($scope.cart[i].price*$scope.cart[i].quantLength);
                        }
                        sessionStorage.setItem('cart',JSON.stringify($scope.cart));
                    }



                    $scope.openLeftMenu = function() {
                        $mdSidenav('left').toggle();
                        $scope.placeOrder=false;
                    };

                    $scope.mobileMenu = function () {
                        $("body").animate({ scrollTop: 0 }, "fast",function () {
                            $mdSidenav('super-menu').toggle();
                        });
                    }


                }])


                .controller('fatafatCategoriesCtrl', ['$scope','$rootScope','$window', '$timeout','$location','API','$routeParams',function( $scope, $rootScope, $window,$timeout,$location,API,$routeParams) {
                $window.scrollTo(0, 0);




                         $scope.selectedCity={};

                    sessionStorage.removeItem('cart');

                          var cityName = $routeParams.city_name;

                    cityName = cityName.charAt(0).toUpperCase() + cityName.substr(1).toLowerCase();
                    $scope.selectedCityName = cityName;
                    if(cityName=="Chandigarh")
                        {
                           var city= "Chandigarh-Tricity"
                        }
                    else
                        {
                            city=cityName
                        }
                    $scope.title = 'Jugnoo ' + cityName + ' | Order Fruits, Vegetables & Groceries online';
                    $scope.description = ' Buy fresh fruits and vegetables, best quality grocery and household essentials online at best prices in ' + city;


                    $scope.cities=
                        [{"city_id":1,"city_name":"Chandigarh","latitude":30.719047,"longitude":76.810808},{"city_id":2,"city_name":"Ludhiana","latitude":30.90828,"longitude":75.851521},{"city_id":7,"city_name":"Gurgaon","latitude":28.460817,"longitude":77.076807},{"city_id":8,"city_name":"Indore","latitude":22.727078,"longitude":75.85766},{"city_id":11,"city_name":"Ahmedabad","latitude":23.027264,"longitude":72.58056},{"city_id":17,"city_name":"Noida","latitude":28.5885,"longitude":77.3611},{"city_id":4,"city_name":"Jaipur","latitude":26.871286,"longitude":75.78079},{"city_id":14,"city_name":"Vadodara","latitude":22.3196,"longitude":73.1669},{"city_id":22,"city_name":"Bhubaneswar","latitude":20.3028,"longitude":85.8239},{"city_id":21,"city_name":"Mysore","latitude":12.3111,"longitude":76.6426},{"city_id":15,"city_name":"Surat","latitude":21.1544,"longitude":72.8197},{"city_id":25,"city_name":"Coimbatore","latitude":11.0093,"longitude":76.9624}];

                         for(i=0;i<$scope.cities.length;i++)
                             {
                                 if(cityName==$scope.cities[i].city_name)
                                     {
                                         $scope.selectedCity=$scope.cities[i];
                                         break;
                                     }
                             }



                    $rootScope.loading_custom = true;

                    API.post(fatafat_base_url+'get_super_categories', {
                         access_token: guestToken,
                         latitude:localStorage.getItem('lat'),
                            longitude:localStorage.getItem('long'),
                        device_type:2,

                    })
                        .then(function (result) {
                            $scope.subCatList=result.data.super_categories;
                            $rootScope.loading_custom = false;
                         $scope.flag=result.data.flag;
                        $scope.msg=result.data.message;

                        })

                    $scope.getItems=function (subCatId) {
                        console.log(subCatId);

                        $location.path("/grocery/"+cityName.toLowerCase()+"/"+subCatId)
                        console.log("sdfgsjhdvsjck")
                        }

                    $scope.msg = '';
            }])

        /*.directive('googleplace', function() {
            return {
                require: 'ngModel',
                link: function(scope, element, attrs, model) {
                    var options = {
                        types: [],
                        componentRestrictions: {}
                    };
                    scope.gPlace = new google.maps.places.Autocomplete(element[0], options);

                    google.maps.event.addListener(scope.gPlace, 'place_changed', function() {
                        scope.$apply(function() {
                            model.$setViewValue(element.val());
                        });
                    });
                }
            };
        });*/